import { ApiServiceBase } from '../api-service-base';
import { IPlaybookBankAnnotated } from '../types';
import {
  CreateDraftExperimentFromPlaybookArguments,
  CreateDraftExperimentFromPlaybookResult,
  GetFeaturedPlaybooksArguments,
  GetPlaybookBankArguments,
} from './types';

export class PlaybookBankService extends ApiServiceBase {
  constructor() {
    super('shops');
  }

  async getFeaturedPlaybooks({
    shopId,
  }: GetFeaturedPlaybooksArguments): Promise<IPlaybookBankAnnotated[]> {
    const url = `${this.serviceBaseUri}/${shopId}/playbook-bank/featured`;
    const response = await this.httpService.get({ url });
    return (response.data?.playbooks ?? []) as IPlaybookBankAnnotated[];
  }

  async getPlaybookBank({ shopId }: GetPlaybookBankArguments): Promise<IPlaybookBankAnnotated[]> {
    const url = `${this.serviceBaseUri}/${shopId}/playbook-bank`;
    const response = await this.httpService.get({ url });
    return (response.data?.playbooks ?? []) as IPlaybookBankAnnotated[];
  }

  async createDraftExperiment({
    shopId,
    playbookId,
  }: CreateDraftExperimentFromPlaybookArguments): Promise<CreateDraftExperimentFromPlaybookResult> {
    const url = `${this.serviceBaseUri}/${shopId}/playbook-bank/${playbookId}/draft-experiment`;
    const response = await this.httpService.post({ url });
    return (response.data ?? {}) as CreateDraftExperimentFromPlaybookResult;
  }
}

export const playbookBankService = new PlaybookBankService();
